import { SET_OVERLAY } from '../types.js';

const initialState = {
  login: false,
  profile: false,
  highFives: false,
  video: false,
  shotcuts: false,
  employees: false,
  happinessFollowUp: false,
  settings: false,
}

export default function reducerState (state = initialState, action) {
  switch(action.type) {
    case SET_OVERLAY :
      return { ...state, [action.screen] : action.action }
    default:
      return state;
  }
}
